export default __webpack_public_path__ + "static/media/G.44d14014.mp3";